// eslint-disable-next-line import/prefer-default-export
export const SET_ERROR = 'SET_ERROR';